﻿import { OpaccArticlePrice } from "./opacc.article-price.js";
import { default as OpaccDateRangeL10n } from './vendor/lib/daterangepicker/l10n/index.js';
import { OpaccFormElementDateTimePicker } from './vendor/script/classes/opacc.class.form.element.datetimepicker.js';

export class Project {
	constructor() {

		new OpaccArticlePrice;
        this.contentChangeEventListener();

		this.headerActions = document.querySelector('.header-actions');
        this.userMenu = document.querySelector('.account-link-user-menu');
		this.viewPort = document.querySelector('.viewport');

		this.scrollBar;
		this.initScrollbars();
		this.initScrollbarsDirectSearch();

		// editmode all
		this.editMode = document.querySelectorAll('button[data-op-editmode-all]');
		this.editClass = 'is-changing';

        this.datePickers = document.querySelectorAll('.swa-timepicker');
        if(this.datePickers) {
            this.OpaccFormElementDateTimePicker = new OpaccFormElementDateTimePicker;
            this.initCustomDateTimePickers();
        }

		this.attachEventListener();
		
		this.loadMoreItems = document.querySelector(".opc-segment-navigation .opc-button");
		this.initArticleListScrollObserver();
	}


	attachEventListener() {
		// Edit-Mode aktivieren im Account
		if (this.editMode) {
			Array.from(this.editMode).forEach(button => {
				button.addEventListener('click', event => {
					if (button.getAttribute('data-op-editmode-all') === 'column') {
						event.preventDefault();
						button.setAttribute("data-op-editmode-all", "check");

						let form = button.closest("form");
						let editableColumns = form.querySelectorAll('.editmode');

						Array.from(editableColumns).forEach(e => {
							let column = e.closest(".opc-col");
							if (!column.classList.contains(this.editClass)) {
								column.classList.add(this.editClass);
							}
						})
					}
				});
			});
		}
		if(this.headerActions && this.userMenu) {
			this.viewPort.addEventListener('click', e => {
				if (e.target.closest('.account-link > a')){ 
					e.preventDefault();
					this.userMenu.classList.add("is-open");
				} else {
					this.userMenu.classList.remove("is-open");
				}
			});
		}

		document.addEventListener("click", e => {
			if (e.target.closest('.close-addr-edit-form')){
				e.target.closest('.is-changing').classList.remove("is-changing");
			}
		})
	}

	contentChangeEventListener() {
        let contentWrapper = document.querySelector('.content');
        if(contentWrapper) {
            contentWrapper.addEventListener('change', e => {
				this.loadMoreItems = document.querySelector(".opc-segment-navigation:last-child .opc-button");
                new OpaccArticlePrice;
            });
        }
    }

	initArticleListScrollObserver(){

        document.addEventListener("scroll", e => {

			if(this.loadMoreItems && !this.loadMoreItems.parentElement.parentElement.classList.contains('custadmin')){
				let bounding = this.loadMoreItems.getBoundingClientRect()

				if(this.loadMoreItems.offsetParent !== null) {
					if (
						(bounding.bottom-100) <= (window.innerHeight || document.documentElement.clientHeight)
					) {
						
						
						if(!this.loadMoreItems.classList.contains("is-progress")){
							this.loadMoreItems.click();
						}
					}
				}
			}
		});		
	}

	initScrollbars(){
		let sbfullscreenMenu = document.querySelector('.offcanvas-menu-wrapper');
		if(sbfullscreenMenu != null){
		  this.scrollBar = new SimpleBar(sbfullscreenMenu, {
			autoHide: false,
			forceVisible: false,
		  });
		}
	  }	
	  initScrollbarsDirectSearch(){
		let sbfullscreenMenu = document.querySelector('.search-body');
		if(sbfullscreenMenu != null){
		  this.scrollBar = new SimpleBar(sbfullscreenMenu, {
			autoHide: false,
			forceVisible: false,
		  });
		}
	  }	


      initCustomDateTimePickers() {

        Array.from(this.datePickers).forEach(datePicker => {

            let inputField = datePicker.querySelector('input[type="text"]');
            let langCode = datePicker.dataset.langcode;

            if(inputField) {
                const defaultSettings = {
                    enableTime: true,
                    noCalendar: false,
                    dateFormat: 'd.m.Y H:i',
                    time_24hr: true,
                    minTime: "09:00",
                    maxTime: "18:00",
                    minuteIncrement: 30,
                    enableSeconds: false,
                    appendTo: datePicker,
                    allowInput: true,
					locale: OpaccDateRangeL10n[langCode],
                    minDate: "today",
                    "disable": [
                        function(date) {
                            // return true to disable
                            return (date.getDay() === 0 || date.getDay() === 1);
                
                        }
                    ]
                };

                let timePicker = this.OpaccFormElementDateTimePicker.createDateTimePicker(inputField, defaultSettings);
                this.OpaccFormElementDateTimePicker.triggerDateTimePickerEvents(timePicker);

            }
        });
		}
}


new Project();




